const Menu = [
  { header: 'Xin chào' },
  {
    title: 'Bảng điều khiển',
    group: 'apps',
    icon: 'dashboard',
    name: 'Dashboard',
    url: '/dashboard',
    roles: ['Statistics']
  },
  {
    title: 'Khách hàng',
    group: 'apps',
    icon: 'person',
    name: 'Account',
    url: '/account',
    roles: ['GetAccount']
  },
  {
    title: 'Xe',
    group: 'apps',
    name: 'Vehicle',
    icon: 'motorcycle',
    url: '/vehicle',
    roles: ['GetVehicle']
  },
  {
    title: 'Thiết bị',
    group: 'apps',
    name: 'Device',
    icon: 'dock',
    url: '/device',
    roles: ['GetDevice']
  },
  {
    title: 'Sim',
    group: 'apps',
    name: 'Sim',
    icon: 'sim_card',
    url: '/sim',
    roles: ['GetListSim']
  },
];

// reorder menu
Menu.forEach(item => {
  if (item.items) {
    item.items.sort((x, y) => {
      let textA = x.title.toUpperCase();
      let textB = y.title.toUpperCase();
      return textA < textB ? -1 : textA > textB ? 1 : 0;
    });
  }
});

export default Menu;



// WEBPACK FOOTER //
// ./src/api/menu.js